import { useMutation, useQuery } from '@tanstack/react-query'
import { AxiosError, AxiosResponse } from 'axios'

import {
  deleteData,
  getData,
  patchFormData,
  postData,
  updateData,
  updateFromData,
} from '../../apis/api.helpers'
import apiUrl from '../../apis/api.url'
// import { useSnackbarManager } from '../../common/types'
import { useSnackbarManager } from '../../components/common/snackbar'
import { getErrorMessage, parseQueryParams } from '../../utilities/parsers'

// import { update } from 'lodash'

const buildUrlWithParams = (baseUrl: string, params: any) => {
  return `${baseUrl}${parseQueryParams(params)}`
}

const fetchData = async (input: any) => {
  const response = await getData(
    buildUrlWithParams(`${apiUrl.CLIENT}access-request/list`, {
      ...input,
    })
  )
  return response
}

export const useRequestAccess = (input: any) => {
  return useQuery(['request_access', input], () => fetchData(input), {
    // refetchOnWindowFocus: true,
    //staleTime: 50000,
  })
}

export const getProfileDetails = () => {
  return getData(`${apiUrl.MY_PROFILE}`)
}

export const deleteAccess = (id: string) => {
  return deleteData(`${apiUrl.CLIENT}access-request/${id}`)
}

export const getRequestAccess = (type: string) => {
  return getData(`${apiUrl.CLIENT}access-request/${type}`)
}

export const impersonateUser = (id?: string) => {
  return getData(`${apiUrl.CLIENT}access-request/${id}/spectate`)
}

export const resendOtp = (access_id: string) => {
  return patchFormData(
    `${apiUrl.CLIENT}access-request/${access_id}/resend-otp`,
    {}
  )
}

export const editMyProfile = ({ data }: any) => {
  return patchFormData(`${apiUrl.MY_PROFILE}`, data)
}

export const rejectAccess = (id?: string) => {
  return patchFormData(`${apiUrl.CLIENT}access-request/${id}/reject`, {})
}

export const useEditMyProfile = (handleSubmission: (data: any) => void) => {
  const { enqueueSnackbar } = useSnackbarManager()
  return useMutation(editMyProfile, {
    onSuccess: (res: AxiosResponse | any) => {
      handleSubmission(res.data)
      enqueueSnackbar('Profile updated successfully', {
        variant: 'success',
      })
    },

    onError: (error: AxiosError | any) => {
      enqueueSnackbar(getErrorMessage(error?.response?.data?.detail), {
        variant: 'error',
      })
    },
  })
}

export const requestAccess = (data: any) => {
  return postData(`${apiUrl.CLIENT}access-request`, data)
}

export const useAddAccess = (handleSubmission: (data: any) => void) => {
  const { enqueueSnackbar } = useSnackbarManager()
  return useMutation(requestAccess, {
    onSuccess: (res: any) => {
      handleSubmission(res.data)
      enqueueSnackbar('Access added successfully', { variant: 'success' })
    },

    onError: (error: any) => {
      enqueueSnackbar(
        getErrorMessage(
          error.response.data.error || error?.response?.data?.detail
        ),
        {
          variant: 'error',
        }
      )
    },
  })
}

export const verifyAccess = ({ access_id, data }: any) => {
  return patchFormData(`${apiUrl.CLIENT}access-request/${access_id}`, data)
}

export const useVerifyAccess = (handleSubmission: (data: any) => void) => {
  const { enqueueSnackbar } = useSnackbarManager()

  return useMutation(verifyAccess, {
    onSuccess: (res: AxiosResponse | any) => {
      handleSubmission(res.data)
      enqueueSnackbar('Access Verified successfully', {
        variant: 'success',
      })
    },

    onError: (error: AxiosError | any) => {
      enqueueSnackbar(getErrorMessage(error?.response?.data?.detail), {
        variant: 'error',
      })
    },
  })
}

export const changePassword = (data: any) => {
  return updateData(`change_password`, data)
}

export const updateProfileAttachment = (input: any) => {
  return updateFromData(`${apiUrl.MY_PROFILE_IMAGE}`, input)
}

export const getAppList = (params: any) =>
  getData(`${apiUrl.ACCOUNT_APP}/${parseQueryParams(params)}`)

export const getBglAuthorizeUrl = () => getData(`${apiUrl.BGL_AUTHORIZE}/`)

export const getBglToken = (params: any) =>
  getData(`${apiUrl.BGL_TOKEN}${parseQueryParams(params)}`)

export const updateBglToken = (data: any) => {
  return patchFormData(`${apiUrl.BGL_TOKEN_UPDATE}/`, data)
}
